'use strict';

var React = require('react');

var SvgFulfillmentOnHoldMajor = function SvgFulfillmentOnHoldMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 4h-8v-3h5.227c.382-.001.736.162.928.429l1.845 2.571Zm-15.227-3h5.227v3h-8l1.845-2.571c.192-.267.546-.43.928-.429Zm-2.773 15.5v-10.5h18v2c0 1-1 1-1 1h-1.495c-3.582 0-6.495 2.916-6.495 6.5-.007.433-.01.966-.01 1.5 0 0-.5 1-1.5 1h-6a1.5 1.5 0 0 1-1.5-1.5Zm13.833-4.5a.833.833 0 0 0-.833.833v5a.833.833 0 1 0 1.667 0v-5a.833.833 0 0 0-.834-.833Zm2.5.833a.833.833 0 0 1 1.667 0v5a.833.833 0 1 1-1.667 0v-5Z"
  }));
};

exports.SvgFulfillmentOnHoldMajor = SvgFulfillmentOnHoldMajor;
